"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _Alert = _interopRequireDefault(require("@material-ui/lab/Alert"));

var _styles = require("@material-ui/styles");

var _moment = _interopRequireDefault(require("@date-io/moment"));

var _pickers = require("@material-ui/pickers");

var _core = require("@material-ui/core");

var _DynamicForm = _interopRequireDefault(require("../../components/DynamicForm"));

var _urls = require("../../utils/urls");

var _services = _interopRequireDefault(require("../../services"));

var _utils = _interopRequireDefault(require("../../utils"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }

function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var useStyles = (0, _styles.makeStyles)(function () {
  return {
    container: {
      width: "100%",
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      alignContent: "center"
    },
    title: {
      marginBottom: 50,
      display: "flex",
      marginLeft: "1rem",
      alignItems: "center"
    }
  };
});
window.React = _react.default; // si recibe props.id es para el consumo del form para el usuario final

var FormConsumption = function FormConsumption(props) {
  var match = props.match,
      id = props.id,
      quotationId = props.quotationId,
      history = props.history,
      token = props.token,
      navigate = props.navigate,
      _props$redirect = props.redirect,
      redirect = _props$redirect === void 0 ? null : _props$redirect,
      _props$paramToSave = props.paramToSave,
      paramToSave = _props$paramToSave === void 0 ? null : _props$paramToSave,
      _props$loadData = props.loadData,
      loadData = _props$loadData === void 0 ? null : _props$loadData,
      _props$titleLabel = props.titleLabel,
      titleLabel = _props$titleLabel === void 0 ? "{{name}}" : _props$titleLabel,
      _props$onDataReturn = props.onDataReturn,
      onDataReturn = _props$onDataReturn === void 0 ? null : _props$onDataReturn;
  var classes = useStyles();

  var _useState = (0, _react.useState)(1),
      _useState2 = _slicedToArray(_useState, 2),
      gridSize = _useState2[0],
      setGridSize = _useState2[1];

  var _useState3 = (0, _react.useState)("simple"),
      _useState4 = _slicedToArray(_useState3, 2),
      typeForm = _useState4[0],
      setTypeForm = _useState4[1];

  var _useState5 = (0, _react.useState)(false),
      _useState6 = _slicedToArray(_useState5, 2),
      isAdvance = _useState6[0],
      setIsAdvance = _useState6[1];

  var _useState7 = (0, _react.useState)(2),
      _useState8 = _slicedToArray(_useState7, 2),
      advanceCount = _useState8[0],
      setAdvanceCount = _useState8[1];

  var _useState9 = (0, _react.useState)([]),
      _useState10 = _slicedToArray(_useState9, 2),
      fields = _useState10[0],
      setFields = _useState10[1];

  var _useState11 = (0, _react.useState)(null),
      _useState12 = _slicedToArray(_useState11, 2),
      dataSaved = _useState12[0],
      setDataSaved = _useState12[1];

  var _useState13 = (0, _react.useState)(false),
      _useState14 = _slicedToArray(_useState13, 2),
      loading = _useState14[0],
      setLoading = _useState14[1];

  var newId = (0, _react.useMemo)(function () {
    return match ? match.params.id : id;
  }, [match, id]); // https://test-quotation.iconnectance.com/form-builder/form-saved-data/612fa9d69e5b490012dfc0dd TODO: endpoint a consultar
  // ejecutar cuando quotationId venga definido en url (PUT)

  (0, _react.useEffect)(function () {
    if (paramToSave || quotationId) {
      function fetchData() {
        return _fetchData.apply(this, arguments);
      }

      function _fetchData() {
        _fetchData = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
          var id, _yield$fetcher, data;

          return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  id = paramToSave ? paramToSave : quotationId;
                  _context.next = 3;
                  return (0, _services.default)("".concat(_urls.API_URL, "/form-builder/form-saved-data/").concat(id), token);

                case 3:
                  _yield$fetcher = _context.sent;
                  data = _yield$fetcher.data;
                  data.length && setDataSaved(data);

                case 6:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee);
        }));
        return _fetchData.apply(this, arguments);
      }

      fetchData();
    }
  }, [quotationId, token, paramToSave, loadData]); // loadData

  (0, _react.useEffect)(function () {
    setDataSaved(loadData);
  }, [loadData]);
  var updateDefinition = (0, _react.useCallback)( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var res, url, data;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            setLoading(true);
            _context2.next = 3;
            return (0, _services.default)("".concat(_urls.API_URL, "/form-builder/").concat(newId), token);

          case 3:
            res = _context2.sent;

            if (!Array.isArray(res.data)) {
              url = "/form-builder/lists";
              if (!id && !redirect) history ? history.push(url) : navigate(url);
            } else {
              setGridSize(res.gridSize);
              setTypeForm(res.typeForm);
              setIsAdvance(res.isAdvance);
              setAdvanceCount(res.advanceCount);
              data = res.data.map(function (el) {
                if (dataSaved) {
                  var result = loadData ? Object.keys(dataSaved) : dataSaved;

                  var _iterator = _createForOfIteratorHelper(result),
                      _step;

                  try {
                    var _loop = function _loop() {
                      var key = _step.value;
                      var keyName = loadData ? key : Object.keys(key)[0];
                      var value = loadData ? dataSaved[key] : Object.values(key)[0];

                      if (el.name === keyName) {
                        switch (el.type) {
                          case "radio":
                            el.value = value;
                            break;

                          case "checkbox":
                            el.attributes = el.attributes.map(function (att, i) {
                              att.value = value[i];
                              return att;
                            });
                            break;

                          default:
                            el.attributes.value = value;
                            break;
                        }
                      }
                    };

                    for (_iterator.s(); !(_step = _iterator.n()).done;) {
                      _loop();
                    }
                  } catch (err) {
                    _iterator.e(err);
                  } finally {
                    _iterator.f();
                  }
                }

                return el;
              });
              setLoading(false);
              setFields(_utils.default.saveDataForConsumption(data));
            }

          case 5:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2);
  })), [newId, token, id, redirect, history, navigate, dataSaved, loadData]);

  var handleFields = function handleFields(data) {
    return setFields(data);
  };

  (0, _react.useEffect)(function () {
    updateDefinition();
  }, [updateDefinition]);
  var previewMode = (match === null || match === void 0 ? void 0 : match.params.device) === undefined;
  var isDataSaved = (0, _react.useMemo)(function () {
    return dataSaved !== null && dataSaved !== void 0 && dataSaved.length ? true : false;
  }, [dataSaved]);
  return /*#__PURE__*/_react.default.createElement(_pickers.MuiPickersUtilsProvider, {
    locale: "es",
    utils: _moment.default
  }, /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.container
  }, fields.length > 0 ? /*#__PURE__*/_react.default.createElement(_DynamicForm.default, {
    definition: fields,
    handleFields: handleFields,
    editMode: true,
    previewMode: previewMode,
    detail: false,
    history: history,
    formId: match !== null && match !== void 0 && match.params.device ? match === null || match === void 0 ? void 0 : match.params.device : "",
    gridSize: gridSize,
    typeForm: typeForm,
    isAdvance: isAdvance,
    advanceCount: advanceCount,
    token: token,
    redirect: redirect,
    paramToSave: paramToSave,
    isDataSaved: isDataSaved,
    quotationId: quotationId,
    inside: false,
    titleLabel: titleLabel,
    onDataReturn: onDataReturn
  }) : loading ? /*#__PURE__*/_react.default.createElement(_core.Box, {
    sx: {
      display: "flex"
    }
  }, /*#__PURE__*/_react.default.createElement(_core.CircularProgress, null)) : /*#__PURE__*/_react.default.createElement(_Alert.default, {
    severity: "warning"
  }, /*#__PURE__*/_react.default.createElement("span", null, "No hay definici\xF3n"), /*#__PURE__*/_react.default.createElement("p", null, "No existe informaci\xF3n para construir el preview")))));
};

var _default = FormConsumption;
exports.default = _default;